export interface Wallet {
    address: Array<string>,
    selectedAddress: string
}

export enum WalletTags{
    menu,
    checkout
}

export interface WalletParam {
    type : WalletTags
    isConnected?: Function
}